import React from "react";
import "./EstimatorHow.css";

const steps = [
    {
        number: "01",
        title: "Enter your area",
        text: "Input the total amount you want to cover and select your measuring type.",
    },
    {
        number: "02",
        title: "Select your wall and profile type",
        text: "Choose the wall type and metal profile that suits your project.",
    },
    {
        number: "03",
        title: "Get your materials list",
        text: "The calculator instantly generates the quantity of gypsum boards, screws, metal profiles, joint filler, and anchors needed.",
    },
    {
        number: "04",
        title: "Download your estimate",
        text: "Save your results as a PDF to use as a reference before purchasing materials or starting construction.",
    },
];

const EstimatorHow = () => {
    return (
        <section className="estimator-how">
            <div className="estimator-how__container">
                <span className="estimator-how__tag">HOW IT WORKS</span>
                <h2 className="estimator-how__title">
                    See how <span>calculation works</span>
                </h2>

                <div className="estimator-how__divider" />

                <div className="estimator-how__grid">
                    {steps.map((step) => (
                        <article className="estimator-how__card" key={step.number}>
                            <p className="estimator-how__number">{step.number}</p>
                            <div>
                                <h3>{step.title}</h3>
                                <p>{step.text}</p>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="estimator-how__divider estimator-how__divider--bottom" />
            </div>
        </section>
    );
};

export default EstimatorHow;